"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.knowledge.updated': 'Baza wiedzy awatara została pomyślnie zaktualizowana',
    'avatar.knowledge.load.error': 'Nie udało się załadować wiedzy awatara',
    'avatar.knowledge.update.error': 'Nie udało się zaktualizować wiedzy awatara',
};
